export const OKTA_SSWS_UNAUTHORIZED_EVENT = "idwiz-okta-ssws-unauthorized";

/** Notify OktaSessionProvider to strip the SSWS token and surface reconnect UI (Okta HTTP 401). */
export function dispatchOktaSswsUnauthorized() {
  try {
    window.dispatchEvent(new CustomEvent(OKTA_SSWS_UNAUTHORIZED_EVENT));
  } catch {
    /* ignore */
  }
}
